// @ts-ignore
import { Route, Switch } from 'platform-components/src/components/router/router';
import { withRouterPath, InjectedProps as WithRouterPathHOC } from 'platform-components/hocs';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';

import { ReduxTeacherStore } from '../../typings';
import { getShouldShowFilters } from '../library.store/selectors';

import Breadcrumbs from './__breadcrumbs/sidebar__breadcrumbs';
import Filters from './__filters/sidebar__filters';
import Nav from './__nav/sidebar__nav';

import './sidebar.scss';

interface HOCProps extends WithRouterPathHOC {}

interface StoreProps {
    shouldShowFilters: boolean;
}

interface Props extends StoreProps, HOCProps {
    showBackToCalendarPlan?: boolean;
}

interface Context {
    staticUrls: {
        labLibrarySubjectThemeStacks: string;
        deepLabStacks: string;
    };
}

export const Sidebar = (props: Props, context: Context) => {
    const { shouldShowFilters, showBackToCalendarPlan } = props;
    const { staticUrls } = context;

    return (
        <div className="sidebar">
            <Breadcrumbs showBackToCalendarPlan={showBackToCalendarPlan} />
            <Nav />
            <Switch>
                <Route
                    exact
                    key="libraryThemeRoute"
                    path={staticUrls.labLibrarySubjectThemeStacks}
                    render={() => shouldShowFilters && <Filters mix="sidebar__filters" />}
                />
                <Route
                    exact
                    key="libraryThemeRoute"
                    path={staticUrls.deepLabStacks}
                    render={() => shouldShowFilters && <Filters mix="sidebar__filters" />}
                />
            </Switch>
        </div>
    );
};

const mapStateToProps = (storeState: ReduxTeacherStore, ownProps: HOCProps): StoreProps => {
    const {
        match: {
            params: { subject, themeId },
        },
    } = ownProps;

    return {
        shouldShowFilters: getShouldShowFilters(storeState, {
            themeId: Number(themeId),
            grade: null,
            subject,
        }),
    };
};

Sidebar.contextTypes = {
    staticUrls: PropTypes.object.isRequired,
};

export default withRouterPath(connect(mapStateToProps)(Sidebar));
